import { useT } from "../i18n";
import { Monitor } from "lucide-react";

// Shown (in a tab) when a web user tries to launch SSH/RDP: embedded sessions only run in the
// desktop app. Keeps the unified tab UX consistent across web and desktop. The Download button
// opens the existing DownloadApp modal via the parent.
export function SessionPlaceholder({ itemType, onDownload }: { itemType: "ssh" | "rdp"; onDownload: () => void }) {
  const t = useT();
  return (
    <div className="grid h-full w-full place-items-center bg-bg p-6 text-center">
      <div className="flex max-w-sm flex-col items-center gap-3">
        <Monitor className="h-12 w-12 text-muted" />
        <div className="text-sm font-medium">{t("This session runs in the desktop app")}</div>
        <p className="text-xs text-muted">
          {itemType === "ssh"
            ? t("Embedded SSH sessions are available only in the desktop client.")
            : t("Embedded RDP sessions are available only in the desktop client.")}
        </p>
        <button onClick={onDownload} className="rounded bg-accent px-3 py-1.5 text-sm text-white hover:bg-accent2">
          {t("Download app")}
        </button>
      </div>
    </div>
  );
}
